import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import {
  PageAction,
  PageHeaderComponent,
  PageHeaderIcon,
} from '../page-header/page-header.component';
import { AlertComponent, ToastContainerComponent, ToastConfig } from 'nebula-ui-kit';

@Component({
  selector: 'app-page-container',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, AlertComponent, ToastContainerComponent],
  template: `
    <div class="page-container">
      <div class="page-header-wrapper" [class.is-sticky]="stickyHeader()">
        <app-page-header
          [title]="title()"
          [subtitle]="subtitle()"
          [icon]="icon()"
          [actions]="actions()"
          (actionClick)="action.emit($event)"
        />
      </div>

      @if (showAlert()) {
        <div class="alert-container">
          <lib-alert
            [type]="alertType()"
            [title]="alertTitle()"
            [message]="alertMessage()"
            (closed)="alertClosed.emit()"
            [closeButton]="true"
          ></lib-alert>
        </div>
      }

      <div class="page-content">
        <ng-content></ng-content>
      </div>
    </div>

    <lib-toast-container #toastContainer></lib-toast-container>
  `,
  styleUrls: ['./page-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageContainerComponent implements OnDestroy {
  @ViewChild(ToastContainerComponent) toastContainer!: ToastContainerComponent;

  private destroy$ = new Subject<void>();

  title = input.required<string>();
  subtitle = input<string>();
  icon = input<PageHeaderIcon>();
  actions = input<PageAction[]>([]);
  stickyHeader = input(true);
  action = output<string>();

  showAlert = input<boolean>(false);
  alertType = input<'error' | 'success' | 'warning' | 'info'>('info');
  alertTitle = input<string | undefined>('');
  alertMessage = input<string>('');
  alertClosed = output<void>();

  showToast(config: ToastConfig): void {
    if (this.toastContainer) {
      this.toastContainer.show(config);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.alertClosed.emit();
  }
}
